export default "/images/sponsor1.jpg?cce60b04201cbc26e2a8c27246350e1f";